import { create } from 'zustand'

type ModeloState = {
  selectedModeloResult?: unknown
  selectModeloResult: (payload: unknown) => void
  selectedModeloResultId?: number
  selectModeloResultId: (payload?: number) => void
  identificacaoTabIsValid: boolean
  selectModeloIdentificacaoTabIsValid: (payload: unknown) => void
  detalheTabIsValid: boolean
  selectModeloDetalheTabIsValid: (payload: unknown) => void
  identificacaoTabValidationObject: Record<string, boolean>
  addIdentificacaoTabValidatedField: (payload: Record<string, boolean>) => void
  detalheTabValidationObject: Record<string, boolean>
  addDetalheTabValidatedField: (payload: Record<string, boolean>) => void
}

export const useModeloStore = create<ModeloState>((set, get) => ({
  selectedModeloResult: null,
  identificacaoTabIsValid: false,
  detalheTabIsValid: true,
  identificacaoTabValidationObject: {},
  detalheTabValidationObject: {},
  selectModeloResult: (payload: unknown) =>
    set({ selectedModeloResult: payload }),
  selectModeloResultId: (payload?: number) =>
    set({ selectedModeloResultId: payload }),
    selectModeloIdentificacaoTabIsValid: (payload?: any) =>
    set({ identificacaoTabIsValid: payload }),
    selectModeloDetalheTabIsValid: (payload?: any) =>
    set({ identificacaoTabIsValid: payload }),
  addIdentificacaoTabValidatedField: (payload) => {
    const validationObj = get().identificacaoTabValidationObject
    const newValidationObj = { ...validationObj, ...payload }
    set({ identificacaoTabValidationObject: newValidationObj })
    const validationValues = Object.values(newValidationObj)
    set({
      identificacaoTabIsValid: validationValues.every(
        (value) => value === true
      ),
    })
  },
  addDetalheTabValidatedField: (payload) => {
    const validationObj = get().detalheTabValidationObject
    const newValidationObj = { ...validationObj, ...payload }
    set({ detalheTabValidationObject: newValidationObj })
    const validationValues = Object.values(newValidationObj)
    set({
      detalheTabIsValid: validationValues.every(
        (value) => value === true
      ),
    })
  },
}))
